<template>
  <div class="bank-picker-item" :class="{active}">
    <div class="flex-none mr-4 w-9-5 h-9-5 rounded-full">
      <img :src="bank.logo_url" :alt="`${bank.code}_logo`">
    </div>
    <div class="text-text-secondary text-sm leading-relaxed truncate" :title="bank.alias || bank.name">{{ bank.alias || bank.name }}</div>
    <IconTickSquare v-if="active" class="flex-none ml-auto text-green mx-1"/>
  </div>
</template>

<script>
import IconTickSquare from "@/components/icons/IconTickSquare";

export default {
  name: "BankPicketItem",
  components: {IconTickSquare},
  props: {
    active: {
      type: Boolean,
      required: true
    },
    bank: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.bank-picker-item {
  @apply flex items-center py-2 px-2-7 rounded cursor-pointer transition duration-200;
  max-width: 100%;
  &:hover,
  &.active {
    @apply bg-border;
  }
}
</style>